<script setup lang="tsx">
import { ref, watchEffect } from "vue";
import { __color } from "@zyzgroup/core-web";
import { mapState } from "../../context/context";

const props = withDefaults(
  defineProps<{
    color?: string;
    borderColor?: string;
  }>(),
  {}
);

const mappedState = mapState([
  "color.secondaryPattern",
  "color.secondaryBorderPattern"
]);

const color = ref();
const closetColor = ref();
const borderColor = ref();

watchEffect(() => {
  color.value = props.color || mappedState["color.secondaryPattern"].value;
  closetColor.value = __color.set(color.value).closet().toString();
  borderColor.value =
    props.borderColor || mappedState["color.secondaryBorderPattern"].value;
});
</script>

<template>
  <!-- 不设置 width="150" height="150" 自适应父元素 -->
  <!-- viewBox : x y width height , 可重设 viewBox 切除四周多余空白 -->
  <svg
    viewBox="0 0 150 150"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="none"
    fill="none"
    :style="{
      display: 'block',
      transformOrigin: 'center'
    }"
  >
    <path
      d="M22.5 28.5C21.95 28.5 21.5 28.05 21.5 27.5V17.5C21.5 16.95 21.95 16.5 22.5 16.5C23.05 16.5 23.5 16.95 23.5 17.5V27.5C23.5 28.05 23.05 28.5 22.5 28.5Z"
      :fill="borderColor"
    />
    <path
      d="M27.5 23.5H17.5C16.95 23.5 16.5 23.05 16.5 22.5C16.5 21.95 16.95 21.5 17.5 21.5H27.5C28.05 21.5 28.5 21.95 28.5 22.5C28.5 23.05 28.05 23.5 27.5 23.5Z"
      :fill="borderColor"
    />
    <path
      d="M142.5 13.5C145.261 13.5 147.5 11.2614 147.5 8.5C147.5 5.73858 145.261 3.5 142.5 3.5C139.739 3.5 137.5 5.73858 137.5 8.5C137.5 11.2614 139.739 13.5 142.5 13.5Z"
      :fill="closetColor"
    />
    <path
      d="M142.5 5.5C144.155 5.5 145.5 6.845 145.5 8.5C145.5 10.155 144.155 11.5 142.5 11.5C140.845 11.5 139.5 10.155 139.5 8.5C139.5 6.845 140.845 5.5 142.5 5.5ZM142.5 3.5C139.74 3.5 137.5 5.74 137.5 8.5C137.5 11.26 139.74 13.5 142.5 13.5C145.26 13.5 147.5 11.26 147.5 8.5C147.5 5.74 145.26 3.5 142.5 3.5Z"
      :fill="borderColor"
    />
    <path
      d="M70 145.5H40C39.45 145.5 39 145.05 39 144.5C39 143.95 39.45 143.5 40 143.5H70C70.55 143.5 71 143.95 71 144.5C71 145.05 70.55 145.5 70 145.5Z"
      :fill="borderColor"
    />
    <path
      d="M110 145.5H80C79.45 145.5 79 145.05 79 144.5C79 143.95 79.45 143.5 80 143.5H110C110.55 143.5 111 143.95 111 144.5C111 145.05 110.55 145.5 110 145.5Z"
      :fill="borderColor"
    />
    <path
      d="M75.5 145.5H74.5C73.95 145.5 73.5 145.05 73.5 144.5C73.5 143.95 73.95 143.5 74.5 143.5H75.5C76.05 143.5 76.5 143.95 76.5 144.5C76.5 145.05 76.05 145.5 75.5 145.5Z"
      :fill="borderColor"
    />
    <path
      d="M46.25 138.5H1.25C0.7 138.5 0.25 138.05 0.25 137.5C0.25 136.95 0.7 136.5 1.25 136.5H46.25C46.8 136.5 47.25 136.95 47.25 137.5C47.25 138.05 46.8 138.5 46.25 138.5Z"
      :fill="borderColor"
    />
    <path
      d="M121.25 138.5H56.25C55.7 138.5 55.25 138.05 55.25 137.5C55.25 136.95 55.7 136.5 56.25 136.5H121.25C121.8 136.5 122.25 136.95 122.25 137.5C122.25 138.05 121.8 138.5 121.25 138.5Z"
      :fill="borderColor"
    />
    <path
      d="M51.75 138.5H50.75C50.2 138.5 49.75 138.05 49.75 137.5C49.75 136.95 50.2 136.5 50.75 136.5H51.75C52.3 136.5 52.75 136.95 52.75 137.5C52.75 138.05 52.3 138.5 51.75 138.5Z"
      :fill="borderColor"
    />
    <path
      d="M148.75 138.5H131.25C130.7 138.5 130.25 138.05 130.25 137.5C130.25 136.95 130.7 136.5 131.25 136.5H148.75C149.3 136.5 149.75 136.95 149.75 137.5C149.75 138.05 149.3 138.5 148.75 138.5Z"
      :fill="borderColor"
    />
    <path
      d="M126.75 138.5H125.75C125.2 138.5 124.75 138.05 124.75 137.5C124.75 136.95 125.2 136.5 125.75 136.5H126.75C127.3 136.5 127.75 136.95 127.75 137.5C127.75 138.05 127.3 138.5 126.75 138.5Z"
      :fill="borderColor"
    />
    <path
      d="M75.5 122.5C105.876 122.5 130.5 97.8757 130.5 67.5C130.5 37.1243 105.876 12.5 75.5 12.5C45.1243 12.5 20.5 37.1243 20.5 67.5C20.5 97.8757 45.1243 122.5 75.5 122.5Z"
      :fill="color"
    />
    <path
      d="M75.5 14.5C104.725 14.5 128.5 38.275 128.5 67.5C128.5 96.725 104.725 120.5 75.5 120.5C46.275 120.5 22.5 96.725 22.5 67.5C22.5 38.275 46.275 14.5 75.5 14.5ZM75.5 12.5C45.125 12.5 20.5 37.125 20.5 67.5C20.5 97.875 45.125 122.5 75.5 122.5C105.875 122.5 130.5 97.875 130.5 67.5C130.5 37.125 105.875 12.5 75.5 12.5Z"
      :fill="borderColor"
    />
    <path
      d="M75.5 100C78.2614 100 80.5 97.7614 80.5 95C80.5 92.2386 78.2614 90 75.5 90C72.7386 90 70.5 92.2386 70.5 95C70.5 97.7614 72.7386 100 75.5 100Z"
      :fill="closetColor"
    />
    <path
      d="M75.5 92C77.155 92 78.5 93.345 78.5 95C78.5 96.655 77.155 98 75.5 98C73.845 98 72.5 96.655 72.5 95C72.5 93.345 73.845 92 75.5 92ZM75.5 90C72.74 90 70.5 92.24 70.5 95C70.5 97.76 72.74 100 75.5 100C78.26 100 80.5 97.76 80.5 95C80.5 92.24 78.26 90 75.5 90Z"
      :fill="borderColor"
    />
    <path
      d="M75.5 85C73.3 85 71.5 83.2 71.5 81V39C71.5 36.8 73.3 35 75.5 35C77.7 35 79.5 36.8 79.5 39V81C79.5 83.2 77.7 85 75.5 85Z"
      :fill="closetColor"
    />
    <path
      d="M75.5 37C76.605 37 77.5 37.895 77.5 39V81C77.5 82.105 76.605 83 75.5 83C74.395 83 73.5 82.105 73.5 81V39C73.5 37.895 74.395 37 75.5 37ZM75.5 35C73.3 35 71.5 36.8 71.5 39V81C71.5 83.2 73.3 85 75.5 85C77.7 85 79.5 83.2 79.5 81V39C79.5 36.8 77.7 35 75.5 35Z"
      :fill="borderColor"
    />
    <path
      d="M130.5 111.5C129.95 111.5 129.5 111.05 129.5 110.5V100.5C129.5 99.95 129.95 99.5 130.5 99.5C131.05 99.5 131.5 99.95 131.5 100.5V110.5C131.5 111.05 131.05 111.5 130.5 111.5Z"
      :fill="borderColor"
    />
    <path
      d="M135.5 106.5H125.5C124.95 106.5 124.5 106.05 124.5 105.5C124.5 104.95 124.95 104.5 125.5 104.5H135.5C136.05 104.5 136.5 104.95 136.5 105.5C136.5 106.05 136.05 106.5 135.5 106.5Z"
      :fill="borderColor"
    />
    <path
      d="M8 119C10.7614 119 13 116.761 13 114C13 111.239 10.7614 109 8 109C5.23858 109 3 111.239 3 114C3 116.761 5.23858 119 8 119Z"
      :fill="closetColor"
    />
    <path
      d="M8 111C9.655 111 11 112.345 11 114C11 115.655 9.655 117 8 117C6.345 117 5 115.655 5 114C5 112.345 6.345 111 8 111ZM8 109C5.24 109 3 111.24 3 114C3 116.76 5.24 119 8 119C10.76 119 13 116.76 13 114C13 111.24 10.76 109 8 109Z"
      :fill="borderColor"
    />
  </svg>
</template>
